const GET_DATOS = (state, datos) => {
    state.datos = datos
}

export default { GET_DATOS }